var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeaderIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 80,
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.0003 60H70.0003C71.8337 60 73.3337 58.5 73.3337 56.6667C73.3337 54.8333 71.8337 53.3333 70.0003 53.3333H20.0003C18.167 53.3333 16.667 54.8333 16.667 56.6667C16.667 58.5 18.167 60 20.0003 60ZM20.0003 43.3333H70.0003C71.8337 43.3333 73.3337 41.8333 73.3337 40C73.3337 38.1667 71.8337 36.6667 70.0003 36.6667H20.0003C18.167 36.6667 16.667 38.1667 16.667 40C16.667 41.8333 18.167 43.3333 20.0003 43.3333ZM36.667 23.3333C36.667 25.1667 38.167 26.6667 40.0003 26.6667H70.0003C71.8337 26.6667 73.3337 25.1667 73.3337 23.3333C73.3337 21.5 71.8337 20 70.0003 20H40.0003C38.167 20 36.667 21.5 36.667 23.3333Z",
  fill: "#162C2B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.9317 22.5339C30.0477 22.6508 30.0477 22.8394 29.9317 22.9563L20.88 32.0841C20.7627 32.2024 20.5713 32.2024 20.454 32.0841L18.5269 30.1409C18.4109 30.0238 18.411 29.835 18.5272 29.7181L23.6325 24.5842C23.6952 24.5212 23.6506 24.4137 23.5616 24.4137L9.9781 24.4137C9.92287 24.4137 9.8781 24.4585 9.8781 24.5137L9.8781 59.8C9.8781 59.9657 9.74379 60.1 9.5781 60.1L6.86699 60.1C6.70131 60.1 6.56699 59.9657 6.56699 59.8L6.56699 21.3765C6.56699 21.2108 6.70131 21.0765 6.86699 21.0765L23.5616 21.0765C23.6506 21.0765 23.6952 20.969 23.6325 20.906L18.5272 15.7721C18.411 15.6552 18.4109 15.4664 18.5269 15.3493L20.454 13.4061C20.5713 13.2878 20.7627 13.2878 20.88 13.4061L29.9317 22.5339Z",
  fill: "#5B7E36",
  stroke: "#5B7E36",
  strokeWidth: 0.2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/headerIcon.3aa2c285bde7fe9f9ac907b58e856aa7.svg";